module.exports = __webpack_public_path__ + "static/media/25.0638df8c.png";